import { NullValueObject } from '@/utils/value-objects/null-value-object.js';

export class NullProbeId extends NullValueObject {}
